export default __webpack_public_path__ + "static/preview-a6c7e7a60e2f9b286a209110c31d42f9.png";